module.exports = __webpack_public_path__ + "img/holidu.7cbb4226.svg";